import {GET_TSTABLE_REPORT_INPUT, GET_TSTABLE_REPORT_OUTPUT, CLEAR_TSTABLE_REPORT} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function tsReportReducer(state = initialState.tsReport, action) {
  let newState;

  switch (action.type) {

    case GET_TSTABLE_REPORT_INPUT:
        newState = objectAssign({}, state, {input: action.reportData})
        return newState;
    
    case GET_TSTABLE_REPORT_OUTPUT:
        newState = objectAssign({}, state, {output: action.reportData})
        return newState;

    case CLEAR_TSTABLE_REPORT:
        newState = objectAssign({}, state, {
          input: {
            tsID: "",
            network_name: "",
            programs: [],
            tables: []
          },
          output: {
            tsID: "",
            network_name: "",
            programs: [],
            tables: []
          }
        })
        return newState;

    default:
      return state;
  }
}
